import {useEffect, useState} from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Images
import {useNavigate} from "react-router-dom";
import {Card, Divider, InputLabel} from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import properties from "constants/ApplicationConstants";

function Performance_Improvement_List() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card>
        <MDBox pt={4} pb={3} px={3}>
          <InputLabel
            sx={{fontWeight: "bold", fontFamily: properties.fontFamily}}
            id="Performance_Improvement_List"
            mb={2}
          >
            Performance Improvement List
          </InputLabel>
        </MDBox>
        <Divider />

        <MDBox mt={2} mb={4} gap={1.5}>
          {/* <MDBox component="ul"
                                            sx={({ breakpoints }) => ({
                                            display: "flex",
                                            flexWrap: "wrap",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            listStyle: "none",
                                            mt: 3,
                                            mb: 0,
                                            p: 0,
                                            gap:2,
                                            [breakpoints.up("lg")]: {
                                                mt: 0,
                                            },
                                            })}>
                                            <MDButton variant="outlined" color="info" sx={4} href={Pdf} target = "_blank">
                                                View Evaluation Flow
                                            </MDButton>
                                            <MDButton variant="gradient" color="info" sx={4} href={Pdf} target = "_blank">
                                                Current Year Evaluation Form
                                            </MDButton>
                                            <MDButton variant="gradient" color="info" sx={4} href={Pdf} target = "_blank">
                                                Previous Data
                                            </MDButton>
                                            <MDButton variant="gradient" color="info" sx={4} href={Pdf} target = "_blank">
                                                Assigned Goals
                                            </MDButton>
                                        </MDBox> */}
        </MDBox>
      </Card>
    </DashboardLayout>
  );
}

export default Performance_Improvement_List;
